import React from 'react';
import { aboutData } from '../data/mock';
import { GraduationCap, Users, Monitor, Shield } from 'lucide-react';

const AboutSection = () => {
  const features = [
    { icon: GraduationCap, label: "Gestão" },
    { icon: Monitor, label: "Sistemas de Informação" },
    { icon: Users, label: "Recursos Humanos" },
    { icon: Shield, label: "Cibersegurança" }
  ];

  return (
    <section id="about" className="py-24 md:py-32 bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Title */}
        <div className="text-center mb-14">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-5">
            {aboutData.title}
          </h2>
          <div className="w-24 h-1.5 bg-[#DA8347] mx-auto rounded-full" />
        </div>

        {/* Content */}
        <div className="max-w-4xl mx-auto space-y-6 text-gray-600 text-lg md:text-xl leading-relaxed">
          {aboutData.content.map((paragraph, index) => (
            <p key={index}>{paragraph}</p>
          ))}
        </div>

        {/* Features Grid */}
        <div className="mt-20 grid grid-cols-2 md:grid-cols-4 gap-6">
          {features.map((feature, index) => (
            <div
              key={index}
              className="group bg-gray-50 rounded-2xl p-8 text-center transition-all duration-300 hover:bg-[#DA8347] hover:shadow-xl hover:-translate-y-1"
            >
              <feature.icon
                className="w-14 h-14 mx-auto mb-5 text-[#DA8347] group-hover:text-white transition-colors duration-300"
              />
              <span className="font-semibold text-lg text-gray-800 group-hover:text-white transition-colors duration-300">
                {feature.label}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
